export type HEXColor = string;

export const COLORS = {
  WHITE: '#ffffff',
  BLACK: '#121212',
  BLACK_PRIMARY: '#252525',
  BLACK_SECONDARY: '#353535',
  ORANGE_PRIMARY: '#F17100',
  ORANGE_PRIMARY_LIGHT: '#F7AA66',
  PEACH: '#F89030',
  PEACH_LIGHT: '#F890301A',
  ORANGE_SECONDARY: '#FBD4B2',
  ORANGE_SEMI: '#F171004D',
  YELLOW: '#E7C302',
  RED_CORAL: '#ED4926',
  RED_CORAL_HOVER: '#c43b1d',
  DEEP_CRIMSON: '#CE3C1B',
  LIGHT_RED: '#FF383C',
  DARK_GREEN_PALE: '#0052471A',
  PINK: '#F83078',
  LIGHTER_RED: '#FF383C0D',
  DEEP_CRIMSON_PALE: '#CE3C1B1A',
  RED_RECKHAM: '#CE3C1B14',
  LIGHT_CRIMSON: '#CE3C1B33',
  GREY: '#707070',
  GREY_BORDER: '#D2D2D2',
  GREY_FADED: '#7F7F7F1',
  GREY_FADED_A: '#7F7F7F1A',
  GREY94: '#F0F0F0',
  LIGHT_SILVER: '#D8D8D8',
  GREY_DARK: '#4C4C4C',
  RED: 'red',
  GREY_CLASSIC: '#444444',
  GREY_MEDIUM: '#7B7B7B',
  SILVER_OLD: '#858585',
  DIVIDER: '#CCCCCC',
  LIGHT_WHITE_SMOKE: '#F8F8F8',
  YELLOW_GOLD: '#C9A61A',
  GREY_SUVA: '#8C8C8C',
  GRAPHITE_GREY: '#7B7B7B',
  GREY_LIGHT: '#F9F7F9',
  GREY_DIM: '#6F6F6F',
  GREY_BRIGHT: '#E9E8E8',
  GREY_NERO: '#232323',
  GRAY_STATUS: '#767676',
  GREY_ALUMINUM: '#DFDFDF',
  GRAY_STATUS_SECONDARY: '#DEDEDE',
  GRAY_CLOUD: '#DEDEDE',
  GAINSBORO: '#D9D9D9',
  WHITE_SMOKE: '#EDEDED',
  GREY_VERY_LIGHT: '#CBCBCB',
  SILVER: '#C5C5C5',
  BEIGE: '#FFE9D1',
  BORDER: '#EAEAEA',
  GRAY_LIGHT: '#FCFCFC',
  DEEP_PURPLE: '#261057',
  BG_SECONDARY: '#F8F8FE',
  DARK_PURPLE: '#0F0B55',
  DUSK_BLUE: '#3053A0',
  JORDY_BLUE: '#9CB8F5',
  DARK_BLUE: '#07074A',
  LIGHT_PURPLE: '#BBBBF9',
  LIGHT_BLUE: '#E6EEFF',
  DARK_GREEN: '#005247',
  GREEN_TREE: '#1C9219',
  DARK_GREEN_LIGHT: '#00524733',
  GREEN: '#48C641',
  GREEN_OLIVE: '#1C92191A',
  BLUE: '#3063f8',
  MINT: '#C4FCF0',
  BLUE_CHILL: '#449B90',
};

export const FONT_WEIGHTS = {
  BOLD: 700,
  SEMI_BOLD: 600,
  SEMI_NORMAL: 500,
  NORMAL: 400,
  SMALL: 300,
};

export const FONT_SIZES = {
  '10': '0.625rem',
  '12': '0.75rem',
  '14': '0.875rem',
  '15': '0.9375rem',
  '16': '1rem',
  '18': '1.125rem',
  '20': '1.25rem',
  '22': '1.375rem',
  '24': '1.5rem',
  '26': '1.6rem',
  '28': '1.75rem',
  '30': '1.875rem',
  '32': '2rem',
  '36': '2.25rem',
  '38': '2.375rem',
  '40': '2.5rem',
  '46': '2.9rem',
  '48': '3rem',
  '56': '3.5rem',
};

export const MOBILE_LAYOUT_MAX_WIDTH = 1024;

const SCREEN_SIZES = {
  MOBILE_S: '320px',
  MOBILE: '375px',
  MOBILE_L: '425px',
  MOBILE_XL: '480px',
  TABLET_S: '641px',
  TABLET: '834px',
  LAPTOP_S: '1025px',
  LAPTOP_M: '1366px',
  LAPTOP: '1440px',
  DESKTOP_S: '1600px',
  DESKTOP: '1920px',
  DESKTOP_L: '2560px',
};

export const SHADOWS = {
  LIGHTEST: `0px 3px 8px -1px rgba(50, 50, 71, 0.05), 0px 0px 1px 0px rgba(12, 26, 75, 0.24);`,
  LIGHTER: `0px 4px 20px -2px rgba(50, 50, 71, 0.08), 0px 0px 1px 0px rgba(12, 26, 75, 0.10);`,
  LIGHT: `0px 1px 2px rgba(50, 50, 71, 0.08), 0px 0px 1px rgba(50, 50, 71, 0.2)`,
  MEDIUM: `0px 0px 1px rgba(12, 26, 75, 0.24),
  0px 3px 8px -1px rgba(50, 50, 71, 0.05)`,
  BIG: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  SOLID_LIGHT: `0px 1px 3px rgba(0, 0, 0, 0.3);`,
  SOLID_MEDIUM: `0px 1px 8px 0px rgba(0, 0, 0, 0.25)`,
  MEDIUM_BLURRED: `0px 1px 8px 0px #00000040;`,
  ITEM_SHADOW: `0px 3px 8px -1px #3232470D`,
  ADVANTAGE_SHADOW: `0 0 11px rgba(107, 107, 107, 0.35)`,
  BOTTOM: `0px 1px 1px 0px #00000026`,
};

export const DEVICES = {
  MOBILE_S: `(min-width: ${SCREEN_SIZES.MOBILE_S})`,
  MOBILE: `(min-width: ${SCREEN_SIZES.MOBILE})`,
  MOBILE_L: `(min-width: ${SCREEN_SIZES.MOBILE_L})`,
  MOBILE_XL: `(min-width: ${SCREEN_SIZES.MOBILE_XL})`,
  TABLET_S: `(min-width: ${SCREEN_SIZES.TABLET_S})`,
  TABLET: `(min-width: ${SCREEN_SIZES.TABLET})`,
  LAPTOP_S: `(min-width: ${SCREEN_SIZES.LAPTOP_S})`,
  LAPTOP_M: `(min-width: ${SCREEN_SIZES.LAPTOP_M})`,
  LAPTOP: `(min-width: ${SCREEN_SIZES.LAPTOP})`,
  DESKTOP_S: `(min-width: ${SCREEN_SIZES.DESKTOP_S})`,
  DESKTOP: `(min-width: ${SCREEN_SIZES.DESKTOP})`,
  DESKTOP_L: `(min-width: ${SCREEN_SIZES.DESKTOP_L})`,
};
